import { render, staticRenderFns } from "./PackagingTypesTable.vue?vue&type=template&id=a6a735e2&scoped=true"
import script from "./PackagingTypesTable.vue?vue&type=script&lang=js"
export * from "./PackagingTypesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a735e2",
  null
  
)

export default component.exports